import {debounce, animateBlock, addSubmenuButton, anchorLinks, lazyImage} from './modules/helpers.js';
import initFakeSelects  from './modules/initFakeSelects';
import { handleMainFormSubmit, initMainFormValidationClear, initMainForms, openMainFormPopup } from './modules/mainForm.js';
import { initContactsForms } from './modules/contactsForm.js';
import { initFooterFeedbackForms } from './modules/footerFeedbackForm.js';
import { initPhoneCountrySelects } from './modules/phoneCountrySelect.js';

// Take some useful functions
import {
	closest_polyfill,
} from './modules/helpers.js';

/**
 * All custom code is wrapped in IIFE function
 * to prevent affect our code to another parts of code
 */
;(function ( $ ) {
    
    lazyImage();
    
	/**
	 * Occurs when all HTML has been fully loaded and passed by the parser,
	 * without waiting for the stylesheets, images and frames to finish loading
	 */
		document.addEventListener("DOMContentLoaded", function(event) {
		// Init Closest polyfill method ( Don't delete it )
			closest_polyfill();
        
        initFakeSelects(); //innit custom select
        
        animateBlock(); // innit animate block function
        initRepeaterTextMarquees();
        initStepsSliders();
        initBlogSliders();
        initBeforeAfterSliders();
        initBeforeAfterComparisons();
        initMainFormValidationClear();
        initMainForms();
        initContactsForms();
        initFooterFeedbackForms();
        initPhoneCountrySelects();

        $( document.body )
            .off( 'updated_checkout.checkoutLazyImages' )
            .on( 'updated_checkout.checkoutLazyImages', lazyImage );

       /* addSubmenuButton('#menu-header-menu', `<svg viewBox="0 0 9.24805 5.43411" xmlns="http://www.w3.org/2000/svg" width="9.248047" height="5.434113" fill="none" customFrame="#000000"><path id="Vector" d="M0 0L4.21875 4.21875L8.4375 0" fill-rule="nonzero" stroke="rgb(114,113,120)" stroke-width="1.145833" transform="matrix(1,0,0,-1,0.405273,5.02899)" /></svg>`); // innit add for submenu button*/
       const mainSlider = document.querySelector('.js-main-slider');
       
		/**
		 * Add global handler for click event
		 * The main idea - to improve site performance
		 * We added only 1 event handler to "click" event
		 * and then use date-role attribute on each( needed ) elements
		 * to define on which element event was executed.
		 */
		document.body.addEventListener( 'click', event => {
			const clickTarget = event.target;

			if ( clickTarget.closest( '.js-site-menu .mobile-menu__nav a' ) ) {
				closeMobileMenu();
			}

			const clickElem = clickTarget.closest('[data-role]');
			const ROLE = clickElem ? clickElem.dataset.role : null;

			if ( !ROLE ) return;
            switch ( ROLE ) {
                case 'set-page' : {
                    event.preventDefault();
                    const page = clickElem?.dataset?.page ? parseInt(clickElem.dataset.page, 10) : 1;
                    if (typeof loadFilteredProducts === 'function') {
                        loadFilteredProducts(page, { scrollToBlock: true });
                    }
                } break;
                case 'open-modal': {
                    event.preventDefault();
                    const body = document.querySelector('body');
                    const popupSelector = clickElem.dataset.popup;
                    if(!popupSelector) return;
                    const popup = document.querySelector(`#${popupSelector}`);
                    close_popups();
                    
                    if(popup) {
                        popup.classList.add('show');
                        body && body.classList.add('menu-open');
                    }
                } break;
                case 'close-popup': {
                    close_popups();
                } break;
                case 'open-popup': {
                    event.preventDefault();
                    const popupId = clickElem.dataset.popup;

                    if ( popupId === 'main_form_popup' ) {
                        openMainFormPopup();
                        return;
                    }

                    if ( !popupId ) {
                        return;
                    }

                    const popup = document.getElementById( popupId );

                    close_popups();

                    if ( popup ) {
                        popup.classList.add( 'show' );
                        popup.setAttribute( 'aria-hidden', 'false' );
                        document.body.classList.add( 'menu-open' );
                    }
                } break;
                case 'close-menu': {
                    event.preventDefault();
                    closeMobileMenu();
                } break;
                case 'open-mobile-menu': {
                    event.preventDefault();
                    openMobileMenu();
                } break;
                case 'toggle-faq': {
                    event.preventDefault();
                    toggleFaqItem(clickElem);
                } break;
                case 'cart-quantity-minus': {
                    event.preventDefault();
                    updateCartQuantity(clickElem, -1);
                } break;
                case 'cart-quantity-plus': {
                    event.preventDefault();
                    updateCartQuantity(clickElem, 1);
                } break;
                case 'add-to-cart': {
                    event.preventDefault();
                    handleAddToCart(clickElem);
                } break;
			}
		} );

		document.addEventListener( 'keydown', event => {
			if ( event.key !== 'Escape' ) {
				return;
			}

			const menu = document.querySelector( '.js-site-menu' );

			if ( menu && !menu.classList.contains( 'hidden' ) ) {
				closeMobileMenu();
			}
		} );
       
       
       /* Add global handler for input event*/
		document.body.addEventListener( 'input', event => {
			const target = event.target;
			const ROLE = target && target.dataset ? target.dataset.role : null;
   
			if ( !ROLE ) return;
			switch ( ROLE ) {
				case 'search-product':
					event.preventDefault();
					break;
			}
		});
        
        /* Add global handler for change event*/
		document.body.addEventListener( 'change', event => {
			const target = event.target;
			const ROLE = target && target.dataset ? target.dataset.role : null;

			if ( !ROLE ) return;
			switch ( ROLE ) {
				case 'cart-quantity-input': {
					updateCartItemQuantity(target);
				} break;
			}
		} );
	});


	// Use it when you need to know that everything is loaded (html, styles, images)
	window.addEventListener('load', (event) => {});

})( jQuery );


function closeMobileMenu() {
	const menu = document.querySelector( '.js-site-menu' );
	const body = document.querySelector( 'body' );

	if ( !menu ) {
		return;
	}

	menu.classList.add( 'hidden' );
	menu.setAttribute( 'aria-hidden', 'true' );
	body && body.classList.remove( 'menu-open' );
}

function openMobileMenu() {
	const menu = document.querySelector( '.js-site-menu' );

	if ( !menu ) {
		return;
	}

	close_popups();
	menu.classList.remove( 'hidden' );
	menu.setAttribute( 'aria-hidden', 'false' );
	document.body.classList.add( 'menu-open' );
}

function close_popups () {
	closeMobileMenu();

    const popups = document.querySelectorAll('.js-popup');
    const body = document.querySelector('body');
    if(popups) {
        popups.forEach( item => {
            item.classList.remove('show');
			if ( item.id === 'cart_item_edit_popup' || item.id === 'main_form_popup' || item.id === 'main_form_success_popup' || item.id === 'add_to_cart_success_popup' || item.id === 'quick_order_popup' || item.id === 'quick-order-success' ) {
				item.setAttribute( 'aria-hidden', 'true' );
			}
        })
        
        body && body.classList.remove('menu-open');
    }
}

function updateCartQuantity( button, direction ) {
	const item = button.closest('.cart-item');
	const input = item ? item.querySelector('[data-role="cart-quantity-input"]') : null;

	if ( !input || item.classList.contains( 'is-loading' ) ) {
		return;
	}

	const min = input.min === '' ? 1 : parseInt(input.min, 10);
	const max = input.max === '' ? Infinity : parseInt(input.max, 10);
	const current = parseInt(input.value, 10) || 0;
	const next = Math.max(min, Math.min(max, current + direction));

	if ( next === current ) {
		return;
	}

	input.value = next;
	input.dispatchEvent(new Event('change', { bubbles: true }));
}

function setCartItemLoading( item, isLoading ) {
	item.classList.toggle( 'is-loading', isLoading );
	item.setAttribute( 'aria-busy', isLoading ? 'true' : 'false' );
	item.querySelectorAll( 'button, input' ).forEach( control => {
		control.disabled = isLoading;
	} );
}

async function updateCartItemQuantity( input ) {
	const item = input.closest( '.cart-item' );
	const cartItemKey = item ? item.dataset.cartItemKey : '';
	const previousQuantity = item ? parseInt( item.dataset.cartQuantity, 10 ) || 1 : 1;
	const min = input.min === '' ? 1 : parseInt( input.min, 10 );
	const max = input.max === '' ? Infinity : parseInt( input.max, 10 );
	const requestedQuantity = Math.max( min, Math.min( max, parseInt( input.value, 10 ) || previousQuantity ) );

	if ( !item || !cartItemKey || item.classList.contains( 'is-loading' ) ) {
		input.value = String( previousQuantity );
		return;
	}

	if ( requestedQuantity === previousQuantity ) {
		input.value = String( previousQuantity );
		return;
	}

	input.value = String( requestedQuantity );
	setCartItemLoading( item, true );

	try {
		const formData = new FormData();

		formData.append( 'action', 'update_cart_quantity' );
		formData.append( 'cart_item_key', cartItemKey );
		formData.append( 'quantity', String( requestedQuantity ) );
		formData.append( 'nonce', window.var_from_php?.update_cart_nonce || '' );

		const response = await fetch( window.var_from_php.ajax_url, {
			method: 'POST',
			body: formData,
			credentials: 'same-origin',
		} );
		const result = await response.json();

		if ( !result.success || !result.data ) {
			throw new Error( result.data?.message || 'Cart update failed' );
		}

		const data = result.data;

		input.value = String( data.quantity );
		item.dataset.cartQuantity = String( data.quantity );

		const lineTotal = item.querySelector( '.cart-item__price' );
		const pageCount = document.querySelector( '.js-cart-page-count' );
		const subtotal = document.querySelector( '.js-cart-subtotal' );
		const discount = document.querySelector( '.js-cart-discount' );
		const total = document.querySelector( '.js-cart-total' );

		if ( lineTotal ) lineTotal.innerHTML = data.line_total;
		if ( pageCount ) pageCount.textContent = data.count_text;
		if ( subtotal ) subtotal.innerHTML = data.subtotal;
		if ( discount ) discount.innerHTML = data.discount;
		if ( total ) total.innerHTML = data.total;

		updateHeaderCartCount( data.count );
	} catch ( error ) {
		input.value = String( previousQuantity );
	} finally {
		setCartItemLoading( item, false );
	}
}

function updateHeaderCartCount( count ) {
	document.querySelectorAll( '.js-cart-count' ).forEach( item => {
		item.textContent = String( count );
	} );
}

function openAddToCartSuccessPopup() {
	const popup = document.getElementById( 'add_to_cart_success_popup' );

	if ( !popup ) {
		return;
	}

	close_popups();
	popup.classList.add( 'show' );
	popup.setAttribute( 'aria-hidden', 'false' );
}

async function handleAddToCart( button ) {
	if ( !button || button.disabled || button.classList.contains( 'is-loading' ) ) {
		return;
	}

	const productId = parseInt( button.dataset.id, 10 ) || 0;
	const quantity = parseInt( button.dataset.quantity, 10 ) || 1;

	if ( !productId ) {
		return;
	}

	button.disabled = true;
	button.classList.add( 'is-loading' );

	try {
		const formData = new FormData();

		formData.append( 'action', 'add_to_cart' );
		formData.append( 'product_id', String( productId ) );
		formData.append( 'quantity', String( quantity ) );
		formData.append( 'nonce', window.var_from_php?.add_to_cart_nonce || '' );

		const response = await fetch( window.var_from_php.ajax_url, {
			method: 'POST',
			body: formData,
			credentials: 'same-origin',
		} );

		const result = await response.json();

		if ( result.success && result.data && typeof result.data.count !== 'undefined' ) {
			updateHeaderCartCount( result.data.count );
			openAddToCartSuccessPopup();
		}
	} catch ( error ) {
		// Keep silent fail for UX; button state restores in finally.
	} finally {
		button.disabled = false;
		button.classList.remove( 'is-loading' );
	}
}

function initRepeaterTextMarquees () {
	const marquees = document.querySelectorAll('.js-repeater-text-marquee');

	if ( !marquees.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches ) {
		return;
	}

	marquees.forEach( marquee => {
		const track = marquee.querySelector('.js-repeater-text-track');

		if ( !track || track.dataset.marqueeReady === 'true' ) {
			return;
		}

		track.dataset.marqueeReady = 'true';
		const originalItems = Array.from(track.children);

		if ( !originalItems.length ) {
			return;
		}

		const fillTrack = () => {
			const minWidth = marquee.offsetWidth * 2 + track.scrollWidth;

			while ( track.scrollWidth < minWidth ) {
				originalItems.forEach( item => {
					track.appendChild( item.cloneNode( true ) );
				} );
			}
		};

		const originalWidth = track.scrollWidth;
		fillTrack();

		let offset = originalWidth;
		let previousTime = 0;
		const speed = parseFloat( marquee.dataset.speed ) || 42;

		const animate = currentTime => {
			if ( !previousTime ) {
				previousTime = currentTime;
			}

			const delta = currentTime - previousTime;
			previousTime = currentTime;
			offset -= ( speed * delta ) / 1000;

			if ( offset <= 0 ) {
				offset += originalWidth;
			}

			track.style.transform = `translate3d(${-offset}px, 0, 0)`;
			requestAnimationFrame( animate );
		};

		requestAnimationFrame( animate );

		window.addEventListener( 'resize', debounce( () => {
			fillTrack();
		}, 150 ) );
	} );
}

function initStepsSliders () {
	const sliders = document.querySelectorAll('.js-steps-slider');
	const SwiperConstructor = window.Swiper || ( typeof Swiper !== 'undefined' ? Swiper : null );

	if ( !sliders.length || !SwiperConstructor ) {
		return;
	}

	sliders.forEach( slider => {
		if ( slider.dataset.swiperReady === 'true' ) {
			return;
		}

		slider.dataset.swiperReady = 'true';

		new SwiperConstructor( slider, {
			slidesPerView: 'auto',
			spaceBetween: 38,
			watchOverflow: true,
			breakpoints: {
				0: {
					spaceBetween: 16,
				},
				651: {
					spaceBetween: 28,
				},
				1026: {
					spaceBetween: 38,
				},
			},
		} );
	} );
}

function initBlogSliders () {
	const sliders = document.querySelectorAll('.js-blog-slider');
	const SwiperConstructor = window.Swiper || ( typeof Swiper !== 'undefined' ? Swiper : null );

	if ( !sliders.length || !SwiperConstructor ) {
		return;
	}

	sliders.forEach( slider => {
		if ( slider.dataset.swiperReady === 'true' ) {
			return;
		}

		const slidesCount = slider.querySelectorAll('.swiper-slide').length;

		slider.dataset.swiperReady = 'true';

		new SwiperConstructor( slider, {
			slidesPerView: 3,
			spaceBetween: 30,
			loop: slidesCount > 3,
			speed: 900,
			watchOverflow: true,
			autoplay: {
				delay: 2800,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 16,
				},
				481: {
					slidesPerView: 1,
					spaceBetween: 16,
				},
				651: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				993: {
					slidesPerView: 3,
					spaceBetween: 24,
				},
				1201: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
			},
		} );
	} );
}

function initBeforeAfterSliders () {
	const sliders = document.querySelectorAll('.js-before-after-slider');
	const SwiperConstructor = window.Swiper || ( typeof Swiper !== 'undefined' ? Swiper : null );

	if ( !sliders.length || !SwiperConstructor ) {
		return;
	}

	sliders.forEach( slider => {
		if ( slider.dataset.swiperReady === 'true' ) {
			return;
		}

		const block = slider.closest('.before-after');
		const currentCounter = block ? block.querySelector('.js-before-after-current') : null;
		const totalCounter = block ? block.querySelector('.js-before-after-total') : null;

		const updateCounter = swiper => {
			if ( !currentCounter || !totalCounter ) {
				return;
			}

			currentCounter.textContent = String(swiper.realIndex + 1).padStart(2, '0');
			totalCounter.textContent = String(swiper.slides.length).padStart(2, '0');
		};

		slider.dataset.swiperReady = 'true';

		const beforeAfterSwiper = new SwiperConstructor( slider, {
			slidesPerView: 1,
			spaceBetween: 24,
			watchOverflow: true,
			navigation: {
				prevEl: block ? block.querySelector('.js-before-after-prev') : null,
				nextEl: block ? block.querySelector('.js-before-after-next') : null,
			},
			pagination: {
				el: block ? block.querySelector('.js-before-after-progress') : null,
				type: 'progressbar',
			},
			on: {
				init: updateCounter,
				slideChange: updateCounter,
			},
		} );

		updateCounter(beforeAfterSwiper);
	} );
}

function initBeforeAfterComparisons () {
	const comparisons = document.querySelectorAll('.js-before-after-comparison');

	if ( !comparisons.length ) {
		return;
	}

	comparisons.forEach( comparison => {
		const range = comparison.querySelector('.js-before-after-range');

		if ( !range || range.dataset.comparisonReady === 'true' ) {
			return;
		}

		const updatePosition = () => {
			comparison.style.setProperty('--before-after-position', `${range.value}%`);
		};

		const updateFromPointer = event => {
			const rect = comparison.getBoundingClientRect();
			const position = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100));

			range.value = position.toFixed(2);
			updatePosition();
		};

		let isMouseDragging = false;

		const setParentSwiperTouch = allowTouchMove => {
			const parentSlider = comparison.closest('.js-before-after-slider');

			if ( parentSlider && parentSlider.swiper ) {
				parentSlider.swiper.allowTouchMove = allowTouchMove;
			}
		};

		const updateFromTouch = event => {
			const touch = event.touches && event.touches.length ? event.touches[0] : null;

			if ( !touch ) {
				return;
			}

			updateFromPointer(touch);
		};

		range.dataset.comparisonReady = 'true';
		range.addEventListener('input', updatePosition);
		comparison.addEventListener('pointerdown', event => {
			event.preventDefault();
			event.stopPropagation();
			setParentSwiperTouch(false);
			comparison.setPointerCapture(event.pointerId);
			updateFromPointer(event);
		});
		comparison.addEventListener('pointermove', event => {
			if ( !comparison.hasPointerCapture(event.pointerId) ) {
				return;
			}

			event.stopPropagation();
			updateFromPointer(event);
		});
		comparison.addEventListener('pointerup', event => {
			if ( comparison.hasPointerCapture(event.pointerId) ) {
				comparison.releasePointerCapture(event.pointerId);
			}

			setParentSwiperTouch(true);
		});
		comparison.addEventListener('pointercancel', event => {
			if ( comparison.hasPointerCapture(event.pointerId) ) {
				comparison.releasePointerCapture(event.pointerId);
			}

			setParentSwiperTouch(true);
		});
		comparison.addEventListener('mousedown', event => {
			event.preventDefault();
			event.stopPropagation();
			setParentSwiperTouch(false);
			isMouseDragging = true;
			updateFromPointer(event);
		});
		document.addEventListener('mousemove', event => {
			if ( !isMouseDragging ) {
				return;
			}

			updateFromPointer(event);
		});
		document.addEventListener('mouseup', () => {
			isMouseDragging = false;
			setParentSwiperTouch(true);
		});
		comparison.addEventListener('touchstart', event => {
			event.stopPropagation();
			setParentSwiperTouch(false);
			updateFromTouch(event);
		}, { passive: false });
		comparison.addEventListener('touchmove', event => {
			event.stopPropagation();
			updateFromTouch(event);
		}, { passive: false });
		comparison.addEventListener('touchend', () => {
			setParentSwiperTouch(true);
		});
		comparison.addEventListener('touchcancel', () => {
			setParentSwiperTouch(true);
		});
		updatePosition();
	} );
}

function toggleFaqItem (button) {
	const item = button.closest('.js-faq-item');
	const list = item ? item.closest('.js-faq-list') : null;
	const answer = item ? item.querySelector('.js-faq-answer') : null;
	const isOpen = item ? item.classList.contains('is-open') : false;

	if ( !item || !answer ) {
		return;
	}

	if ( list ) {
		list.querySelectorAll('.js-faq-item.is-open').forEach( openItem => {
			const openButton = openItem.querySelector('[data-role="toggle-faq"]');
			const openAnswer = openItem.querySelector('.js-faq-answer');

			if ( openItem === item ) {
				return;
			}

			openItem.classList.remove('is-open');
			openButton && openButton.setAttribute('aria-expanded', 'false');

			if ( openAnswer ) {
				closeFaqAnswer(openAnswer);
			}
		} );
	}

	if ( isOpen ) {
		item.classList.remove('is-open');
		button.setAttribute('aria-expanded', 'false');
		closeFaqAnswer(answer);
		return;
	}

	item.classList.add('is-open');
	button.setAttribute('aria-expanded', 'true');
	openFaqAnswer(answer);
}

function openFaqAnswer (answer) {
	window.clearTimeout(answer.faqTimer);
	answer.hidden = false;
	answer.style.maxHeight = '0px';

	requestAnimationFrame(() => {
		answer.style.maxHeight = `${answer.scrollHeight}px`;
	});
}

function closeFaqAnswer (answer) {
	window.clearTimeout(answer.faqTimer);
	answer.style.maxHeight = `${answer.scrollHeight}px`;

	requestAnimationFrame(() => {
		answer.style.maxHeight = '0px';
	});

	answer.faqTimer = window.setTimeout(() => {
		const item = answer.closest('.js-faq-item');

		if ( answer.style.maxHeight === '0px' && ! item?.classList.contains('is-open') ) {
			answer.hidden = true;
		}
	}, 300);
}
